import { isPopover, isPopoverArray, isString, isStringArray } from '../../../utils/typeHelper'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import PopOver, { IPopover } from '../../PopOver'
import _ from 'lodash'

interface IDefaultInputProps {
  id: any
  text: string
  control?: any
  defaultValue?: any
  onChange?: any
  errorMessage?: any
  errorKey?: any
  className?: any
  disabled?: boolean
  selectRef?: any
  errors?: any
  isRequired?: boolean
  type?: string
  textClassName?: string
  labelInfo?: string[] | string | IPopover[] | IPopover
}

const Input: FC<IDefaultInputProps> = (props: IDefaultInputProps) => {
  const {
    id,
    text,
    errors,
    selectRef,
    defaultValue,
    disabled,
    errorMessage,
    control,
    className,
    onChange,
    isRequired = true,
    type = 'text',
    textClassName = '',
    labelInfo,
  } = props
  const { t } = useTranslation()

  const [popoverData, setPopoverData] = useState<IPopover[]>()

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      if (isString(labelInfo))
        setPopoverData([
          {
            id: 'popover-' + id,
            body: t(labelInfo),
          } as IPopover,
        ])
      else if (isStringArray(labelInfo)) {
        const data = labelInfo.map((m, i) => {
          return <label key={'popover-content-' + i}>{t(m)}</label>
        })
        setPopoverData([
          {
            id: 'popover-' + id,
            body: data,
          },
        ])
      } else if (isPopoverArray(labelInfo)) {
        setPopoverData(labelInfo as IPopover[])
      } else if (isPopover(labelInfo)) {
        setPopoverData([labelInfo as IPopover])
      }
    }
    return () => {
      isMounted = false
      setPopoverData([])
    }
  }, [labelInfo])

  return (
    <div className={className}>
      <div className="form-group">
        <label htmlFor={id} className={textClassName}>
          {t(text)}
          {isRequired && <strong className="text-danger">*</strong>}
          {popoverData &&
            !_.isEmpty(popoverData) &&
            popoverData.map((m, i) => {
              return (
                <PopOver
                  key={'popover-comp-' + i}
                  placement={m.placement}
                  id={'popover-comp-' + i}
                  body={m.body}
                  className={m.className}
                  bodyClassName={m.bodyClassName}
                  headerClassName={m.headerClassName}
                  header={m.header}
                  icon={m.icon}
                ></PopOver>
              )
            })}
        </label>
        <input
          disabled={disabled}
          id={id}
          className={cx('form-control', {
            'is-invalid': errors[id],
          })}
          type={type}
          name={id}
          ref={selectRef}
          defaultValue={defaultValue}
          onChange={onChange}
        />
        {errors && errors[id] && <div className="invalid-feedback">{errors[id].message}</div>}
      </div>
    </div>
  )
}

export default Input
